import { View } from 'react-native';
import styled from '@ui/styled';

const FlexedView = styled({
  flex: 1,
}, 'FlexedView')(View);

export default FlexedView;



// WEBPACK FOOTER //
// ./src/@ui/FlexedView.js